export const filterRange = (rows:any, columnIds:any, filterOpts: any):boolean => {
	const dbLoc = filterOpts.meta.databaseLocation ?? columnIds;
	const { value } = filterOpts;
	return value[0] <= rows.original[dbLoc] && value[1] >= rows.original[dbLoc];
}
